import * as React from 'react'
import { FetchUserDetailsQuery } from '../../../../common/src/types.gen'
import validate from '../../../../common/src/validate'
import { Field } from '../components/EditBox'
import EditBoxes from '../components/EditBoxes'

export default class UserEditBoxesADP extends React.PureComponent<{
  user: FetchUserDetailsQuery['user']
  onPatch: (patch: any) => any
}> {
  render() {
    const { user } = this.props

    const fields = [
      {
        key: 'adpFirstName',
        isEditable: true,
        isOptional: true,
        textFunc: (val: string) => (val === undefined || val === '' ? 'no ADP first name' : val),
        editTextFunc: (val: string) => val || '',
        placeholder: 'ADP first name',
        validator: validate.str().empty(''),
      },
      {
        key: 'adpLastName',
        isEditable: true,
        isOptional: true,
        textFunc: (val: string) => (val === undefined ? 'no ADP last name' : val),
        editTextFunc: (val: string) => val || '',
        placeholder: 'ADP last name',
        validator: validate.str().empty(''),
      },
      {
        key: 'adpUserId',
        isEditable: false,
        textFunc: (val: string) => (val === undefined ? 'waiting to fetch ADP user id' : val),
        placeholder: 'ADP user id',
        colorFunc: (val: string) => (val != null ? 'mint' : undefined),
        iconFunc: (val: string) => (val != null ? 'check' : 'contact-prospect-offered'),
        tooltip: 'ADP sync happens at 8pm Pacific, fetches ADP user ID given legal name',
      },
    ].filter(f => f) as Field<any>[]

    return <EditBoxes model={user} fields={fields} displayType="small" onEdit={this.onEditBound} />
  }

  private onEditBound = (key: string, value: any) => {
    const { onPatch } = this.props
    const patch: any = {}
    patch[key] = value
    return onPatch(patch)
  }
}
